module.exports = __webpack_public_path__ + "static/media/promoValidateHeader.3660ac50.jpg";